export default __webpack_public_path__ + "static/node@2x-434617687a2e6b5a34a5ef2bdb37ad5d.png";